import { memo, useEffect, useRef, useState , useCallback} from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableContainer from '@mui/material/TableContainer';
import Typography from '@mui/material/Typography';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import { useTheme } from '@mui/material/styles';
import { formatter, changeCurrency, PERMISSION_MODEL, constants } from '../../../constants';
import moment from 'moment';
import { Button, Checkbox, Dialog, LinearProgress } from '@mui/material';
import CustomersApp from './NewCustomersComponents/CustomersApp';
import Tooltip from '@mui/material/Tooltip';
import OriginalJobLabel from 'app/main/loadz/components/OriginalJobLabel';
import Check_refresh from '../Check_refresh';
import { useDispatch } from 'react-redux';
import { showMessage } from 'app/store/fuse/messageSlice';
import TableSortLabel from '@mui/material/TableSortLabel';
import { useHistory } from 'react-router-dom';
import _ from '@lodash';
import ModalAfterPay from '../Payments/components/ModalAfterPay';
import { connect } from 'react-redux';
import ErrorBoundary from '../ErrorBoundary';
import client from 'client';
import { hasPermission } from '../loadz/utils';
import TableFooter from '@mui/material/TableFooter';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import PreviewIcon from '@mui/icons-material/Preview';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import { BolTable } from './NewCustomersComponents/BolTable';
import store from 'app/store';
import FuseLoading from '@fuse/core/FuseLoading';
import PaymentDialog from '../Invoices/Invoices/Modals/ViewPaymentModalShow';
import { paymentVoidReturnLabel } from '../Invoices/Invoices/Modals/paymentStatus';
import ReceiptEmailPopup from '../Invoices/Invoices/Modals/ReceiptEmailPopup';
import {useTranslation} from 'react-i18next';

let jobsToFill = [];

// Who registered the payment (payments.posted_by, resolved to a name by the API).
const postedByLabel = (payment, t) => {
  if (payment?.posted_by_name) return payment.posted_by_name;
  if (payment?.source_type === 'Web Payment') {
    return t('POSTED_BY_ONLINE', 'Customer (online payment)');
  }
  return t('POSTED_BY_NOT_RECORDED', 'Not recorded');
};

function TablePaginationActions(props) {
  const {t} = useTranslation('navigation');
  const theme = useTheme();
  const history = useHistory();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label={t('FIRST_PAGE')}
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label={t('PREVIOUS_PAGE')}>
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label={t('NEXT_PAGE')}
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label={t('LAST_PAGE')}
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

function RowInvoices(props) {
  const {
    row,
    openModalViewInvoice,
    setTickets,
    setInfo,
    openModalEditInvoice,
    handleApplyPaymentInvoice,
    viewInvoice,
    payments,
  } = props;

  const dispatch = useDispatch();
  
  useEffect(() => {
    viewInvoice.current = handleClickView;
  }, []);

  const [order, setOrder] = useState({
    direction: 'asc',
    id: null,
  });

  const clear = () => {
    setTickets([]);
    setInfo({});
  };

  const handleClickView = (tickets, info) => {
    clear();
    setTickets(tickets);
    setInfo(info);
    openModalViewInvoice.current(false);
  };

  const handleClickEdit = (tickets, info) => {
    clear();
    setTickets(tickets);
    setInfo(info);
    openModalEditInvoice.current(false);
  };

  const createSortHandler = (property) => (event) => {
    handleRequestSort(event, property);
  };

  function handleRequestSort(event, property) {
    const id = property;
    let direction = 'desc';

    if (order.id === property && order.direction === 'desc') {
      direction = 'asc';
    }

    setOrder({
      direction,
      id,
    });
  }

  const checkDays = (a, b) => {
    let st = moment()._d;
    let ed = moment(b)._d;
    if (st > ed) {
      // debugger
      let finalDataFormCurrent = moment().diff(moment(a), 'days');
      //  debugger
      return <TableCell sx={{ color: 'red' }}>{`${finalDataFormCurrent}`}</TableCell>;
    } else {
      // debugger
      let finalDataFromDue = moment().diff(moment(a), 'days');
      //  debugger
      return `${finalDataFromDue}`;
    }
  };
  
  //create function that will mimic getData function from view invoice 
  const [openViewReceipt, setOpenViewReceipt] = useState(false);
  const [toTable, setTotable] = useState([]);
  const [paymentData, setPaymentData] = useState({});
  const [loaderData, setLoaderData] = useState(false);
  const [paymentReceiptData, setPaymentReceiptData] = useState(null);
  

  const _showMessage = (message) => {
    dispatch(
      showMessage({
        message: message, //text or html
        autoHideDuration: 6000, //ms
        anchorOrigin: {
          vertical: 'top', //top bottom
          horizontal: 'right', //left center right
        },
        variant: 'error', //success error info warning null
      })
    );
  };

  const handleViewReceipt = async(paymentInfo,allPayments) => {
    try {
          setLoaderData(true);
          setPaymentData(paymentInfo);
          setPaymentReceiptData(allPayments);

          const result = await client.post('/invoices/get-invoice',{invoice_id:paymentInfo.invoice_id})
          //console.log('result==>>',result.data);
    
          let _rows = [];

          const jobs = await client.post(
            `/invoices/tickets-invoices/${store.getState().loadz_auth.AuthReducer.user.company.compacctnum}`,
            { tickets: result.data.tickets_gli }
          );

          const jsonJobs = jobs.data;
          if (jsonJobs && jsonJobs.length > 0) {
            jsonJobs[0].customer.jobs.forEach((job, index) => {
              let dueDateSet = moment(moment(), 'MM/DD/YYYY')
                .add(jsonJobs[0].customer.customerTerm, 'days')
                .format('MM/DD/YYYY');
              jsonJobs[0].customer.jobs[index].newDueDate = dueDateSet;
            });
          }

          if (jsonJobs && jsonJobs.length > 0) {
            if (jsonJobs[0].customer && jsonJobs[0].customer.jobs) {
              if (jsonJobs[0].customer.companyLogo) {
                jsonJobs[0].customer['blobResLOGO'] = jsonJobs[0].customer.companyLogo;
              }
            }
          }

          if (jsonJobs.msg) {
            //_showMessage(jsonJobs.msg);
            throw 'Error fetching data!'
          }

          _rows = jsonJobs;
          if (_rows && _rows.length > 0) {
            // const logo = await getImage(_rows[0].customer.companyLogo);
            let logo = null;
            if (_rows[0]?.customer?.companyLogo) {
              logo = _rows[0]?.customer?.companyLogo.includes('http')
                ? _rows[0].customer.companyLogo
                : `${constants.URLLOCAL}/aws/signed?image=${_rows[0].customer.companyLogo}`;
            }

            console.log('toTable as rows: ', _rows);
            setTotable(_rows);

          }

          setLoaderData(false);
          setOpenViewReceipt(true);
    
      
    
        } catch (error) {
          console.log('handleViewReceipt ERROR => ',error);
          setLoaderData(false);
          setOpenViewReceipt(false);
          setTotable([]);
          setPaymentData({});
          setPaymentReceiptData(null);
          _showMessage('Error fetching data!');}
  }

  const closeDialog = () => {
    setOpenViewReceipt(false);
    setTotable([]);
    setPaymentData({});
    setPaymentReceiptData(null);
  };

  const {t} = useTranslation('navigation');

  return (
    <>
      {
        loaderData ?
        <Dialog open={loaderData}>
          <FuseLoading/>
        </Dialog>
        : 
        null
      }

      <PaymentDialog
        isOpen={openViewReceipt}
        paymentData={paymentData}
        closeModal={closeDialog}
        toTable={toTable}
        paymentReceiptData={paymentReceiptData}
      />
      <Box border={1} sx={{ backgroundColor: '#f9f9f9', margin: 1, width: '100%' }}>
        <Table sx={{ tableLayout: 'auto' }} size='small' aria-label={t('PURCHASES')}>
          <TableHead>
            <TableRow>
              {payments?.length > 0 ? (
                <>
                  <TableCell
                    align='center'
                    sortDirection={order.id === 'invoiceNo' ? order.direction : false}
                  >
                    <Tooltip title={t('SORT')} enterDelay={300}>
                      <TableSortLabel
                        align='center'
                        active={order.id === 'invoice_no'}
                        direction={order.direction}
                        onClick={createSortHandler('invoice_no')}
                        className='font-Regular'
                      >
                        {t('INVOICE_NO')}
                      </TableSortLabel>
                    </Tooltip>
                  </TableCell>
                  {/* <TableCell align="center">Invoice No.</TableCell> */}
                  <TableCell align='center'>{t('VALUE_OF_PAYMENT')}</TableCell>
                  <TableCell align='center'>{t('REFERENCE')}</TableCell>
                  <TableCell align='center'>{t('PAYMENT_DATE')}</TableCell>
                  <TableCell align='center'>{t('POSTED_BY', 'Posted By')}</TableCell>
                  <TableCell
                    align='center'
                    style={{ backgroundColor: payments.payment_status ? '#ffcccc' : '' }}
                  >
                    {t('STATUS_PAY')}
                  </TableCell>
                  <TableCell
                    align='center'
                    style={{ backgroundColor: payments.payment_status ? '#ffcccc' : '' }}
                  >
                    {t('VIEW_PAYMENT')}
                  </TableCell>
                </>
              ) : (
                <>
                  <TableCell align='center'>{t('INVOICE_NO')}</TableCell>
                  <TableCell align='center'>{t('TOTAL_HAULING')}</TableCell>
                  <TableCell align='center'>{t('TOTAL_MATERIAL')}</TableCell>
                  <TableCell align='center'>{t('TOTAL_MATERIAL_TAXES')}</TableCell>
                  <TableCell align='center'>{t('TOTAL_WAIT_TIME')}</TableCell>
                  <TableCell
                    align='center'
                    sortDirection={order.id === 'balance' ? order.direction : false}
                  >
                    <Tooltip title={t('SORT')} enterDelay={300}>
                      <TableSortLabel
                        align='center'
                        active={order.id === 'balance'}
                        direction={order.direction}
                        onClick={createSortHandler('balance')}
                        className='font-Regular'
                      >
                        {t('BALANCE')}
                      </TableSortLabel>
                    </Tooltip>
                  </TableCell>
                  <TableCell align='center'>{t('TOTAL')}</TableCell>
                  <TableCell align='center'>{t('TICKETS')}</TableCell>
                  <TableCell align='center'>{t('DUE_DATE')}</TableCell>
                  <TableCell align='center'>{t('AGING')}</TableCell>
                  <TableCell align='center'>{t('DATE_TIME_UPDATED')}</TableCell>
                  <TableCell align='center'>{t('EDIT')}</TableCell>

                  {hasPermission(PERMISSION_MODEL.customersViewInvoice) && (
                    <TableCell align='center'>{t('VIEW_INVOICE')}</TableCell>
                  )}
                  {hasPermission(PERMISSION_MODEL.customersApplyPayment) && (
                    <TableCell align='center'>{t('PAY')}</TableCell>
                  )}
                </>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {payments?.length > 0 ? (
              <>
                {_.orderBy(
                  payments,
                  [
                    (o) => {
                      switch (order.id) {
                        case 'invoice_no': {
                          return o[order.id];
                        }
                      }
                    },
                  ],
                  [order.direction]
                ).map((payment, i) => (
                  <>
                    {payments.length + 1 === i + 1 ? (
                      <></>
                    ) : (
                      <>
                        <TableRow key={payment.id}>
                          <TableCell data-headtext={t('INVOICE_NO')} align='center'>
                            {payment.invoice_no}
                          </TableCell>
                          <TableCell data-headtext={t('VALUE_OF_PAYMENT')} align='center'>
                            {formatter.format(payment.amount)}
                          </TableCell>
                          {/* <TableCell data-headtext="Payment Source" align="center">{payment.payment_source}</TableCell> */}
                          <TableCell data-headtext={t('REFERENCE')} align='center'>
                            {payment.reference ? payment.reference : 'N/A'}
                          </TableCell>
                          <TableCell data-headtext={t('PAYMENT_DATE')} align='center'>
                            {moment(payment.date_created).format('LLL')}
                          </TableCell>
                          <TableCell data-headtext={t('POSTED_BY', 'Posted By')} align='center'>
                            {postedByLabel(payment, t)}
                          </TableCell>
                          <TableCell
                            data-headtext={t('PAYMENT_DATE')}
                            align='center'
                            style={{ backgroundColor: payment.status ? '#ffcccc' : '' }}
                          >
                            {paymentVoidReturnLabel(payment) || 'Paid'}
                          </TableCell>
                          <TableCell
                            data-headtext={t('VIEW_PAYMENT')}
                            align='center'
                            style={{ backgroundColor: payment.status ? '#ffcccc' : '' }}
                          >
                            <IconButton onClick={() => {handleViewReceipt(payment,payments)}}><PreviewIcon/></IconButton>
                          </TableCell>
                        </TableRow>
                      </>
                    )}
                  </>
                ))}
              </>
            ) : (
              <>
                {_.orderBy(
                  row,
                  [
                    (o) => {
                      switch (order.id) {
                        case 'balance': {
                          return o[order.id];
                        }
                      }
                    },
                  ],
                  [order.direction]
                ).map((invoice, i) => (
                  <>
                    {row.length + 1 === i + 1 ? (
                      <></>
                    ) : (
                      <>
                        <TableRow key={invoice.invoice}>
                          <TableCell data-headtext={t('INVOICE_NO')} align='center'>
                            {invoice.invoice}
                          </TableCell>
                          <TableCell data-headtext={t('TOTAL_HAULING')} align='center'>
                            {invoice.hauling}
                          </TableCell>
                          <TableCell data-headtext={t('TOTAL_MATERIAL')} align='center'>
                            {invoice.material}
                          </TableCell>
                          <TableCell data-headtext={t('TOTAL_MATERIAL_TAXES')} align='center'>
                            {invoice.taxesMaterial}
                          </TableCell>
                          <TableCell data-headtext={t('TOTAL_WAIT_TIME')} align='center'>
                            {invoice.wait}
                          </TableCell>
                          <TableCell data-headtext={t('BALANCE')} align='center'>
                            {invoice.balance}
                          </TableCell>
                          <TableCell data-headtext={t('TOTAL')} align='center'>
                            {invoice.total}
                          </TableCell>
                          <TableCell data-headtext={t('TICKETS')} align='center'>
                            {invoice.ticketCount}
                          </TableCell>
                          <TableCell data-headtext={t('TICKETS')} align='center'>
                            {moment(invoice.dueDate).format('LL')}
                          </TableCell>
                          {changeCurrency(invoice.balance) != 0 ? (
                            <Tooltip
                              title={`${t('DUE_DATE')} : ${moment(invoice.dueDate).format('LLL')}`}
                              placement='left'
                            >
                              <TableCell align='center' data-headtext={t('AGING')} className='aging'>
                                {checkDays(invoice.dateCreated, invoice.dueDate)}
                              </TableCell>
                            </Tooltip>
                          ) : (
                            <TableCell align='center' data-headtext={t('AGING')} className='aging'>
                              -
                            </TableCell>
                          )}

                          {/* <TableCell align="center">{moment(invoice.dateCreated).format('LLL')}</TableCell> */}
                          <TableCell data-headtext={t('DATE_TIME_UPDATED')} align='center'>
                            {moment(invoice.dateUpdated).format('LLL')}
                          </TableCell>

                          <TableCell data-headtext={t('EDIT')} align='center'>
                            <Tooltip title={t('EDIT_INVOICE')} placement='top'>
                              <IconButton
                                aria-label={t('DELETE')}
                                onClick={() =>
                                  handleClickEdit(invoice.ticketsGli, {
                                    invoice: invoice.invoice,
                                    hauling: invoice.hauling,
                                    material: invoice.material,
                                    taxesMaterial: invoice.taxesMaterial,
                                    wait: invoice.wait,
                                    total: invoice.total,
                                    balance: invoice.balance,
                                    dueDate: invoice.dueDate,
                                    dateCreated: invoice.dateCreated,
                                    notes: invoice.notes,
                                    discount: invoice.discount,
                                    reconcile: invoice.reconcile,
                                  })
                                }
                              >
                                {/* <EditIcon /> */}
                                <img src='./assets/images/edit.svg' style={{ height: '20px' }} />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                          {hasPermission(PERMISSION_MODEL.customersViewInvoice) && (
                            <TableCell data-headtext={t('VIEW_INVOICE')} align='center'>
                              <Tooltip title={t('VIEW_INVOICE')} placement='top'>
                                <IconButton
                                  aria-label={t('DELETE')}
                                  onClick={() =>
                                    handleClickView(invoice.ticketsGli, {
                                      id: invoice.invoiceId,
                                      invoice_id: invoice.invoiceId,
                                      invoice: invoice.invoice,
                                      hauling: invoice.hauling,
                                      material: invoice.material,
                                      taxesMaterial: invoice.taxesMaterial,
                                      wait: invoice.wait,
                                      total: invoice.total,
                                      balance: invoice.balance,
                                      dueDate: invoice.dueDate,
                                      dateCreated: invoice.dateCreated,
                                      notes: invoice.notes,
                                      reconcile: invoice.reconcile,
                                    })
                                  }
                                >
                                  {/* <PreviewIcon /> */}
                                  <img
                                    src='./assets/images/Doller-file.svg'
                                    style={{ height: '20px' }}
                                  />
                                </IconButton>
                              </Tooltip>
                            </TableCell>
                          )}
                          {hasPermission(PERMISSION_MODEL.customersApplyPayment) && (
                            <TableCell data-headtext={t('PAY')} align='center'>
                              <Tooltip title={t('PAY')} placement='top'>
                                <IconButton
                                  disabled={changeCurrency(invoice.balance) === 0 ? true : false}
                                  aria-label={t('PAYMENTS')}
                                  onClick={() => {
                                    handleApplyPaymentInvoice(invoice.invoiceId);
                                  }}
                                >
                                  {/* <PreviewIcon /> */}
                                  <img src='./assets/images/money.svg' style={{ height: '20px' }} />
                                </IconButton>
                              </Tooltip>
                            </TableCell>
                          )}
                        </TableRow>
                      </>
                    )}
                  </>
                ))}
              </>
            )}
          </TableBody>
        </Table>
      </Box>
    </>
  );
}

export function Row(props) {
  const {
    listLoading,
    hasNextPage,
    page,
    getPerCustomer,
    getPaymentPerCustomer,
    row,
    openModalViewInvoice,
    setTickets,
    setInfo,
    openModalEditInvoice,
    handleApplyPaymentInvoice,
    setShowInvoiceInApply,
    infoPayments,
    prop_data,
    tabValue,
    hasGlobalSearched,
    hasGlobalTicketSearched,
    invoiceDate1,
    invoiceDate2,
    setInvoiceDate1,
    setInvoiceDate2,
    handleDateSearch,
    getPerCustomerDate,
    sorting,
    setSorting,
    SortColumn,
    grandTotalHauling,
    grandTotalWait,
    grandTotal,
    grandTotalBalance,
    grandTotalMaterial,
    grandTotalAgent,
    tableLoading,
    setBolData,
    bolData,
    getBolJobs,
    setSelectedBOL,
    selectedBOL,
    updateBOLTicketInvoice
  } = props;

  const [open, setOpen] = useState(false);
  const [selectedTickets, setSelectedTickets] = useState([]);
  const {t} = useTranslation('navigation');

  const handleTicketSelection = (isChecked, invoiceId) => {
    setSelectedTickets((prev) =>
      isChecked ? [...prev, invoiceId] : prev.filter((id) => id !== invoiceId)
    );
  };

  const handleOpen = (open) => {
    setOpen(!open);
  };

  const [scrollX, setScrollX] = useState(0);
  const listInnerRef = useRef();

  const viewInvoice = useRef(null);

  const onScroll = async (event) => {
    console.log('SCROLLING');
    if (listInnerRef.current) {
      const { scrollTop, scrollHeight, clientHeight, scrollLeft, offsetHeight } =
        listInnerRef.current;

      const allow = scrollLeft > scrollX || scrollLeft < scrollX ? false : true;
      setScrollX(scrollLeft);
      if (offsetHeight + scrollTop + 10 >= scrollHeight && allow) {
        console.log('Customer invoice limit', hasNextPage && !listLoading);
        if (!hasGlobalTicketSearched) {
          if (hasNextPage && !listLoading) {
            /* This will be triggered after hitting the last element. API call should be made here while implementing pagination. */
            if (tabValue == 0 || tabValue == 1) {
              if (invoiceDate1 && invoiceDate2) {
                await getPerCustomerDate(page + 1);
              } else {
                await getPerCustomer(page + 1);
              }
            } else if (tabValue === 2) {
              await getPaymentPerCustomer(page + 1);
            }
            else if(tabValue === 3 || tabValue === 4){
              /////////////////////////////////////////////////////////////////////////
              await getBolJobs(page + 1);
            }
          }
        }
      }
    }
  };



  useEffect(() => {
    if (row?.length > 0) {
      const map = new Map();
      //row.invoices
      //-> item.invoices = []
      row.forEach((invoice) => {
        map.set(invoice.invoiceId, () =>
          viewInvoice.current(invoice.ticketsGli, {
            id: invoice.invoiceId,
            invoice_id: invoice.invoiceId,
            invoice: invoice.invoice,
            hauling: invoice.hauling,
            material: invoice.material,
            taxesMaterial: invoice.taxesMaterial,
            wait: invoice.wait,
            total: invoice.total,
            balance: invoice.balance,
            dueDate: invoice.dueDate,
            dateCreated: invoice.dateCreated,
            notes: invoice.notes,
            discount: invoice.discount,
            reconcile: invoice.reconcile,
          })
        );
      });
      setShowInvoiceInApply(map);
    }

    if (!Array.isArray(row)) {
      const map = new Map();
      Object.keys(row).map((key) => {
        //row.invoices
        //-> item.invoices = []
        row?.[key]?.forEach((invoice) => {
          map.set(invoice.invoiceId, () =>
            viewInvoice.current(invoice.ticketsGli, {
              id: invoice.invoiceId,
              invoice_id: invoice.invoiceId,
              invoice: invoice.invoice,
              hauling: invoice.hauling,
              material: invoice.material,
              taxesMaterial: invoice.taxesMaterial,
              wait: invoice.wait,
              total: invoice.total,
              balance: invoice.balance,
              dueDate: invoice.dueDate,
              dateCreated: invoice.dateCreated,
              notes: invoice.notes,
              discount: invoice.discount,
              reconcile: invoice.reconcile,
            })
          );
        });
      });
      setShowInvoiceInApply(map);
    }
  }, [row]);
  // h-max-344

  let localgrandTotalHauling = 0;
  let localgrandTotalWait = 0;
  let localgrandTotal = 0;
  let localgrandTotalBalance = 0;
  let localgrandTotalMaterial = 0;
  let localgrandTotalAgent = 0;

  return (
    <>
      {tableLoading && (
        <Box sx={{ width: '100%' }}>
          <LinearProgress sx={{ width: '100%', height: 5 }} />
        </Box>
      )}
      <TableContainer
        className='w-full overflow-x-scroll overflow-y-scroll'
        style={{ width: '100%', maxHeight: 'calc(90vh - 250px)' }}
        onScroll={listLoading ? null : onScroll}
        ref={listInnerRef}
      >
        <Table style={{ width: '100%' }} stickyHeader={true}>
          <TableHead>
            {infoPayments?.payment?.length > 0 ? (
              <TableRow sx={{ borderBottom: 2 }}>
                <TableCell align='center' className='p-8'></TableCell>
                <TableCell align='center' className='p-8 '>
                  {t('INVOICE_COUNT')}
                </TableCell>
                <TableCell align='center' className='p-8 '>
                  {t('PAYMENT_SOURCE')}
                </TableCell>
                <TableCell align='center' className='p-8 '>
                  {t('REFERENCE')}
                </TableCell>
                <TableCell align='center' className='p-8 '>
                  {t('CONFIRMATION_HASTAG')}
                </TableCell>
                <TableCell align='center' className='p-8 '>
                  {t('AMOUNT_RECEIVED')}
                </TableCell>
                <TableCell align='center' className='p-8 '>
                  {t('PAYMENT_DATE')} *
                </TableCell>
                <TableCell align='center' className='p-8 '>
                  {t('POSTED_BY', 'Posted By')}
                </TableCell>
                <TableCell align='center' className='p-8 '>
                  {t('SEND_RECEIPT')}
                </TableCell>
              </TableRow>
            ) : tabValue == 3 || tabValue == 4 ? (
              <>
                <TableRow>
                  <TableCell align='center'
                  sx={{
                    borderColor: 'black',
                    borderBottom: 2,
                    backgroundColor: 'white',
                  }}
                  >

                  </TableCell>
                  <TableCell
                   align='center'
                  sx={{
                    borderColor: 'black',
                    borderBottom: 2,
                    backgroundColor: 'white',
                  }}
                  >{t('JOB_NO')}</TableCell>
                  <TableCell
                   align='center'
                  sx={{
                    borderColor: 'black',
                    borderBottom: 2,
                    backgroundColor: 'white',
                  }}
                  >{t('BILL_OF_LANDINGS')}.</TableCell>
                  <TableCell
                   align='center'
                  sx={{
                    borderColor: 'black',
                    borderBottom: 2,
                    backgroundColor: 'white',
                  }}
                  >{t('ORIGIN')}.</TableCell>
                  <TableCell
                   align='center'
                  sx={{
                    borderColor: 'black',
                    borderBottom: 2,
                    backgroundColor: 'white',
                  }}
                  >{t('DESTINATION')}</TableCell>
                </TableRow>
              </>
            ) : (
              <TableRow sx={{ borderBottom: 2 }}>
                <TableCell
                  onClick={() => {
                    SortColumn(
                      sorting?.invoice?.active == false
                        ? 'asc'
                        : sorting?.invoice?.order == 'asc'
                        ? 'desc'
                        : 'asc',
                      'invoice'
                    );
                  }}
                  sx={{
                    borderColor: 'black',
                    borderBottom: 2,
                    backgroundColor: 'white',
                    ':hover': { cursor: 'pointer' },
                  }}
                  className=' text-center py-12 top-head'
                >
                  {t('INVOICE_NO')}
                  {sorting?.invoice?.active == true ? (
                    sorting?.invoice?.order == 'asc' ? (
                      <ArrowUpwardIcon fontSize='8px' />
                    ) : (
                      <ArrowDownwardIcon fontSize='8px' />
                    )
                  ) : null}
                </TableCell>

                <TableCell
                  onClick={() => {
                    SortColumn(
                      sorting?.job?.active == false
                        ? 'asc'
                        : sorting?.job?.order == 'asc'
                        ? 'desc'
                        : 'asc',
                      'job'
                    );
                  }}
                  sx={{
                    borderColor: 'black',
                    borderBottom: 2,
                    backgroundColor: 'white',
                    ':hover': { cursor: 'pointer' },
                  }}
                  className=' text-center py-12 top-head'
                >
                  {t('JOB_NO')}
                  {sorting?.job?.active == true ? (
                    sorting?.job?.order == 'asc' ? (
                      <ArrowUpwardIcon fontSize='8px' />
                    ) : (
                      <ArrowDownwardIcon fontSize='8px' />
                    )
                  ) : null}
                </TableCell>

                <TableCell
                  onClick={() => {
                    SortColumn(
                      sorting?.dueDate?.active == false
                        ? 'asc'
                        : sorting?.dueDate?.order == 'asc'
                        ? 'desc'
                        : 'asc',
                      'dueDate'
                    );
                  }}
                  sx={{
                    borderColor: 'black',
                    borderBottom: 2,
                    backgroundColor: 'white',
                    ':hover': { cursor: 'pointer' },
                  }}
                  className=' text-center py-12 top-head'
                >
                  {t('DUE_DATE')}
                  {sorting?.dueDate?.active == true ? (
                    sorting?.dueDate?.order == 'asc' ? (
                      <ArrowUpwardIcon fontSize='8px' />
                    ) : (
                      <ArrowDownwardIcon fontSize='8px' />
                    )
                  ) : null}
                </TableCell>

                <TableCell
                  onClick={() => {
                    SortColumn(
                      sorting?.projectName?.active == false
                        ? 'asc'
                        : sorting?.projectName?.order == 'asc'
                        ? 'desc'
                        : 'asc',
                      'projectName'
                    );
                  }}
                  sx={{
                    borderColor: 'black',
                    borderBottom: 2,
                    backgroundColor: 'white',
                    ':hover': { cursor: 'pointer' },
                  }}
                  className=' text-center py-12 top-head'
                >
                  {t('PROJECT_NAME')}
                  {sorting?.projectName?.active == true ? (
                    sorting?.projectName?.order == 'asc' ? (
                      <ArrowUpwardIcon fontSize='8px' />
                    ) : (
                      <ArrowDownwardIcon fontSize='8px' />
                    )
                  ) : null}
                </TableCell>

                <TableCell
                  onClick={() => {
                    SortColumn(
                      sorting?.balancePending?.active == false
                        ? 'asc'
                        : sorting?.balancePending?.order == 'asc'
                        ? 'desc'
                        : 'asc',
                      'balancePending'
                    );
                  }}
                  sx={{
                    borderColor: 'black',
                    borderBottom: 2,
                    backgroundColor: 'white',
                    ':hover': { cursor: 'pointer' },
                  }}
                  className=' text-center py-12 top-head'
                >
                  {t('BALANCE')}
                  {sorting?.balancePending?.active == true ? (
                    sorting?.balancePending?.order == 'asc' ? (
                      <ArrowUpwardIcon fontSize='8px' />
                    ) : (
                      <ArrowDownwardIcon fontSize='8px' />
                    )
                  ) : null}
                </TableCell>

                <TableCell
                  sx={{ borderColor: 'black', borderBottom: 2, backgroundColor: 'white' }}
                  className=' text-center py-12 top-head'
                >
                  {t('EDIT')}
                </TableCell>

                <TableCell
                  sx={{ borderColor: 'black', borderBottom: 2, backgroundColor: 'white' }}
                  className=' text-center py-12 top-head'
                >
                  {t('VIEW')}
                </TableCell>

                <TableCell
                  sx={{ borderColor: 'black', borderBottom: 2, backgroundColor: 'white' }}
                  className=' text-center py-12 top-head'
                >
                  {t('PAY')}
                </TableCell>
              </TableRow>
            )}
          </TableHead>

          <TableBody className='w-full'>
            {infoPayments?.payment?.length > 0 ? (
              <>
                {infoPayments?.payment?.map((payment) => {
                  return (
                    <ViewPayments
                      payment={payment}
                      row={[]}
                      payments={payment?.payments || []}
                      openModalViewInvoice={openModalViewInvoice}
                      setTickets={setTickets}
                      setInfo={setInfo}
                      openModalEditInvoice={openModalEditInvoice}
                      handleApplyPaymentInvoice={handleApplyPaymentInvoice}
                      viewInvoice={viewInvoice}
                    />
                  );
                })}
              </>
            ) : tabValue == 3 || tabValue == 4 ? (
              <>
                {bolData?.map((data) => (
                  <BolTable
                    data={data}
                    setSelectedBOL={setSelectedBOL}
                    selectedBOL={selectedBOL}
                    tabValue={tabValue}
                  />
                ))}
              </>
            ) : (
              <>
                {row.map((invoice) => {
                  localgrandTotalHauling += parseFloat(invoice.hauling?.replace(/\$|,/g, ''));
                  localgrandTotalWait += parseFloat(invoice.wait?.replace(/\$|,/g, ''));
                  localgrandTotal += parseFloat(invoice.total?.replace(/\$|,/g, ''));
                  localgrandTotalBalance += parseFloat(invoice.balance?.replace(/\$|,/g, ''));
                  localgrandTotalMaterial +=
                    parseFloat(invoice.material?.replace(/\$|,/g, '')) +
                    parseFloat(invoice.taxesMaterial?.replace(/\$|,/g, ''));
                  localgrandTotalAgent += parseFloat(invoice.agent_commission);
                  return (
                    <ViewInvoices
                      invoice={invoice}
                      row={row}
                      payments={[]}
                      openModalViewInvoice={openModalViewInvoice}
                      setTickets={setTickets}
                      setInfo={setInfo}
                      openModalEditInvoice={openModalEditInvoice}
                      handleApplyPaymentInvoice={handleApplyPaymentInvoice}
                      viewInvoice={viewInvoice}
                    />
                  );
                })}
              </>
            )}
          </TableBody>

          {tabValue == 0 || tabValue == 1 ? (
            <TableFooter
              style={{ position: 'sticky', bottom: 0, zIndex: 2, backgroundColor: 'white' }}
            >
              <TableRow>
                <TableCell sx={{ borderColor: 'black', borderTop: 2 }} align='center'>
                  <Typography color={'black'} fontSize={14} sx={{ fontWeight: 'bold' }}>
                    {t('TOTAL')}
                  </Typography>
                </TableCell>
                <TableCell sx={{ borderColor: 'black', borderTop: 2 }}></TableCell>
                <TableCell sx={{ borderColor: 'black', borderTop: 2 }}></TableCell>
                <TableCell sx={{ borderColor: 'black', borderTop: 2 }}></TableCell>

                <TableCell
                  align='start'
                  sx={{ padding: '0px 10px 0px 10px', borderColor: 'black', borderTop: 2 }}
                >
                  <div className='flex'>
                    <div className='flex w-full justify-start align-center'>
                      <Typography sx={{ fontWeight: 'bold' }} color={'black'} fontSize={13}>
                        $
                      </Typography>
                    </div>
                    <div className='flex w-full justify-end align-center'>
                      <Typography sx={{ fontWeight: 'bold' }} color={'black'} fontSize={13}>
                        {grandTotalBalance
                          ? formatter.format(grandTotalBalance).replace('$', '')
                          : formatter.format(localgrandTotalBalance).replace('$', '')}
                      </Typography>
                    </div>
                  </div>
                </TableCell>

                <TableCell sx={{ borderColor: 'black', borderTop: 2 }}></TableCell>
                <TableCell sx={{ borderColor: 'black', borderTop: 2 }}></TableCell>
                <TableCell sx={{ borderColor: 'black', borderTop: 2 }}></TableCell>
              </TableRow>
            </TableFooter>
          ) : null}
        </Table>
      </TableContainer>

      {tabValue == 3 ? (
        <Box sx={{ width: '100%', height: '100%' }}>
          <Button
            style={{
              // position: 'fixed', // Mantiene el botón flotante
              bottom: '20px', // Separación de la parte inferior
              right: '20px', // Separación del lado derecho
              backgroundColor: '#F5C623', // Color amarillo del fondo
              color: '#000', // Color negro del texto
              padding: '10px 20px', // Tamaño del botón
              borderRadius: '25px', // Esquinas redondeadas
              fontFamily: 'Arial, sans-serif', // Fuente
              fontSize: '14px', // Tamaño de texto
              fontWeight: 'bold', // Texto en negrita
              textAlign: 'center', // Texto centrado
              cursor: 'pointer', // Manito al pasar por encima
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.2)', // Sombra del botón
              border: 'none', // Sin borde
              transition: 'transform 0.3s ease, box-shadow 0.3s ease', // Animación suave
              zIndex: '9999', // Asegura que quede por encima de todo
              position: 'absolute',
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 6px 8px rgba(0, 0, 0, 0.3)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.2)';
            }}
            // className='fixed bottom-10 right-10 btn btn-primary'
            variant='contained'
            onClick={async(e) =>  {
              e.stopPropagation();
              await updateBOLTicketInvoice()
              }
             }
          >
            Reconcile
          </Button>
        </Box>
      ) : null}
    </>
  );
}

const ViewPayments = ({
  payment,
  row,
  payments,
  openModalViewInvoice,
  setTickets,
  setInfo,
  openModalEditInvoice,
  handleApplyPaymentInvoice,
  viewInvoice,
}) => {

  const dispatch = useDispatch();
  const { t } = useTranslation('navigation');

  const [opencollapse, setOpenCollapse] = useState(false);

  const [openEmail, setOpenEmail] = useState(false);
  const [toTable, setTotable] = useState([]);
  const [loaderData, setLoaderData] = useState(false);

  const _showMessage = (message,color) => {
      dispatch(
      showMessage({
          message: message, //text or html
          autoHideDuration: 6000, //ms
          anchorOrigin: {
          vertical: 'top', //top bottom
          horizontal: 'right', //left center right
          },
          variant: color, //success error info warning null
      })
      );
  };

  const handleEmailReceipt = async() => {
    try {
      console.log(payment)
          setLoaderData(true);

          const result = await client.post('/invoices/get-invoice',{invoice_id:payment?.payments[0]?.invoice_id})
          //console.log('result==>>',result.data);
    
          let _rows = [];

          const jobs = await client.post(
            `/invoices/tickets-invoices/${store.getState().loadz_auth.AuthReducer.user.company.compacctnum}`,
            { tickets: result.data.tickets_gli }
          );

          const jsonJobs = jobs.data;
          if (jsonJobs && jsonJobs.length > 0) {
            jsonJobs[0].customer.jobs.forEach((job, index) => {
              let dueDateSet = moment(moment(), 'MM/DD/YYYY')
                .add(jsonJobs[0].customer.customerTerm, 'days')
                .format('MM/DD/YYYY');
              jsonJobs[0].customer.jobs[index].newDueDate = dueDateSet;
            });
          }

          if (jsonJobs && jsonJobs.length > 0) {
            if (jsonJobs[0].customer && jsonJobs[0].customer.jobs) {
              if (jsonJobs[0].customer.companyLogo) {
                jsonJobs[0].customer['blobResLOGO'] = jsonJobs[0].customer.companyLogo;
              }
            }
          }

          if (jsonJobs.msg) {
            //_showMessage(jsonJobs.msg);
            throw 'Error fetching data!'
          }

          _rows = jsonJobs;
          if (_rows && _rows.length > 0) {
            // const logo = await getImage(_rows[0].customer.companyLogo);
            let logo = null;
            if (_rows[0]?.customer?.companyLogo) {
              logo = _rows[0]?.customer?.companyLogo.includes('http')
                ? _rows[0].customer.companyLogo
                : `${constants.URLLOCAL}/aws/signed?image=${_rows[0].customer.companyLogo}`;
            }

            //console.log('toTable as rows: ', _rows);
            setTotable(_rows);

          }

          

          setLoaderData(false);
          setOpenEmail(true);
    
      
    
        } catch (error) {
          console.log('handleViewReceipt ERROR => ',error);
          setLoaderData(false);
          setOpenEmail(false);
          setTotable([]);
          _showMessage('Error fetching data!','error');}
  }

  const getCustomerEmail = useCallback(() => {
      let emails = []
      if(toTable && toTable.length && toTable[0].customer && toTable[0].customer.customerEmail){
        emails.push(toTable[0].customer.customerEmail)
      }
  
      //remove block comment to enable emails from customer contacts
      /* if(toTable && toTable.length && toTable[0].customer && toTable[0].customer.customerContact && toTable[0].customer.customerContact.length)
      {
        for(const element of toTable[0].customer.customerContact)
        {
          if(element.email){
            emails.push(element.email)
          }
        }
      } */
  
      //remove block comment to enable emails from customer invoice contacts
      /* if(toTable && toTable.length && toTable[0].customer && toTable[0].customer.invoiceContacts && toTable[0].customer.invoiceContacts.length)
      {
        for(const element of toTable[0].customer.invoiceContacts)
        {
          if(element.email){
            emails.push(element.email)
          }
        }
      } */
  
      return emails;
    }
  ,[toTable]);
  

  return (
    <>

      <Dialog open={loaderData}>
        <FuseLoading/>
      </Dialog>

      {

        toTable && toTable.length ? 
        <ReceiptEmailPopup
          open={openEmail}
          emailhandleOpen={() => setOpenEmail(false)}
          event_id={payment?.payments[0]?.event_id ? payment?.payments[0]?.event_id : null}
          customer_email={getCustomerEmail()}
        />
        : null
      }

      <TableRow key={payment?.id}>
        <TableCell
          className='top-data job__data'
          sx={{ cursor: 'pointer' }}
          onClick={(e) => {
            e.stopPropagation();
            setOpenCollapse(!opencollapse);
          }}
        >
          {opencollapse ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        </TableCell>
        <TableCell className='top-data text-center'>
          <Typography sx={{ fontSize: 'large' }}>{`${payment?.payments?.length}`}</Typography>
        </TableCell>
        <TableCell className='top-data text-center'>
          <Typography
            sx={{ fontSize: 'large' }}
          >{`${payment?.payments?.[0]?.payment_source}`}</Typography>
        </TableCell>
        <TableCell className='top-data text-center'>
          <Typography sx={{ fontSize: 'large' }}>{`${
            payment?.payments?.[0]?.reference || 'N/A'
          }`}</Typography>
        </TableCell>
        <TableCell className='top-data text-center'>
          <Typography sx={{ fontSize: 'large' }}>{`${
            payment?.payments?.[0]?.confirmation_no || 'N/A'
          }`}</Typography>
        </TableCell>
        <TableCell className='top-data text-center'>
          <Typography sx={{ fontSize: 'large' }}>
            {formatter.format(payment?.amount_received)}
          </Typography>
        </TableCell>
        <TableCell className='top-data text-center'>
          <Typography sx={{ fontSize: 'large' }}>
            {moment(payment?.date_created).format('LLL')}
          </Typography>
        </TableCell>
        <TableCell className='top-data text-center'>
          <Typography sx={{ fontSize: 'large' }}>{postedByLabel(payment?.payments?.[0], t)}</Typography>
        </TableCell>
        <TableCell className='top-data text-center'>
          <IconButton sx={{backgroundColor: '#e9c917',borderRadius: '50%'}} onClick={() => {handleEmailReceipt()}}>
            <img
              width="25px"
              height="25px"
              src="/assets/images/icons/email-icon-white.svg"
              style={{marginTop: '0px' }}
            />
          </IconButton>
        </TableCell>
      </TableRow>

      <TableRow>
        <TableCell colSpan={9}>
          <Collapse in={opencollapse} timeout='auto' unmountOnExit>
            <RowInvoices
              row={[]}
              payments={payment?.payments || []}
              openModalViewInvoice={openModalViewInvoice}
              setTickets={setTickets}
              setInfo={setInfo}
              openModalEditInvoice={openModalEditInvoice}
              handleApplyPaymentInvoice={handleApplyPaymentInvoice}
              viewInvoice={viewInvoice}
            />
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

const ViewInvoices = ({
  row,
  payments,
  openModalViewInvoice,
  setTickets,
  setInfo,
  openModalEditInvoice,
  handleApplyPaymentInvoice,
  viewInvoice,
  invoice,
}) => {
  return (
    <RowOnlyInvoices
      invoice={invoice}
      payments={[]}
      openModalViewInvoice={openModalViewInvoice}
      setTickets={setTickets}
      setInfo={setInfo}
      openModalEditInvoice={openModalEditInvoice}
      handleApplyPaymentInvoice={handleApplyPaymentInvoice}
      viewInvoice={viewInvoice}
    />
  );
};

function RowOnlyInvoices(props) {
  const {
    row,
    openModalViewInvoice,
    setTickets,
    setInfo,
    handleApplyPaymentInvoice,
    invoice,
    openModalEditInvoice,
  } = props;
  const [order, setOrder] = useState({
    direction: 'asc',
    id: null,
  });

  const clear = () => {
    setTickets([]);
    setInfo({});
  };

  const handleClickView = (tickets, info) => {
    clear();
    setTickets(tickets);
    setInfo(info);
    openModalViewInvoice.current(false);
  };

  const handleClickEdit = (tickets, info) => {
    clear();
    setTickets(tickets);
    setInfo(info);
    openModalEditInvoice.current(false);
  };

  const createSortHandler = (property) => (event) => {
    handleRequestSort(event, property);
  };

  function handleRequestSort(event, property) {
    const id = property;
    let direction = 'desc';

    if (order.id === property && order.direction === 'desc') {
      direction = 'asc';
    }

    setOrder({
      direction,
      id,
    });
  }
  const {t} = useTranslation('navigation');
  const history = useHistory();
  return (
    <TableRow key={invoice.invoice}>
      <TableCell data-headtext={t('INVOICE_NO')} align='center' size='small' padding='none'>
        {invoice.invoice}
      </TableCell>

      <TableCell data-headtext={t('JOB_NO')} align='center' size='small' padding='none'>
        <Typography
          sx={{
            fontSize: 14,
            fontWeight: 'bold',
            cursor: invoice.jobId ? 'pointer' : 'default',
            width: 'fit-content',
            margin: '0 auto',
            '&:hover': invoice.jobId ? { textDecoration: 'underline' } : undefined,
          }}
          onClick={() => {
            if (invoice.jobId) history.push(`/jobs/ticket/${invoice.jobId}`);
          }}
        >
          {`${invoice.job}`}
        </Typography>
        <OriginalJobLabel job={invoice} variant='compact' />
      </TableCell>

      <TableCell data-headtext={t('DUE_DATE')} align='center' size='small' padding='none'>
        {moment(invoice.dueDate).format('MM/DD/YYYY')}
      </TableCell>

      <TableCell data-headtext={t('PROJECT_NAME')} align='center' size='small' padding='none'>
        {invoice.project_name || '-'}
      </TableCell>

      <TableCell data-headtext={t('BALANCE_PENDING')} align='right' size='small' padding='none'>
        <div className='flex'>
          <div className='flex w-full justify-start align-center'>$</div>
          <div className='flex w-full justify-end align-center'>
            {invoice.balance?.replace('$', '')}
          </div>
        </div>
      </TableCell>

      <TableCell data-headtext={t('EDIT')} align='center' size='small' padding='none'>
        <Tooltip title={t('EDIT_INVOICE')} placement='top'>
          <IconButton
            aria-label={t('DELETE')}
            onClick={() =>
              handleClickEdit(invoice.ticketsGli, {
                invoice: invoice.invoice,
                hauling: invoice.hauling,
                material: invoice.material,
                taxesMaterial: invoice.taxesMaterial,
                wait: invoice.wait,
                total: invoice.total,
                balance: invoice.balance,
                dueDate: invoice.dueDate,
                dateCreated: invoice.dateCreated,
                notes: invoice.notes,
                discount: invoice.discount,
                reconcile: invoice.reconcile,
              })
            }
          >
            {/* <EditIcon /> */}
            <img src='./assets/images/edit.svg' style={{ height: '20px' }} />
          </IconButton>
        </Tooltip>
      </TableCell>

      {hasPermission(PERMISSION_MODEL.customersViewInvoice) && (
        <TableCell data-headtext={t('VIEW_INVOICE')} align='center' size='small' padding='none'>
          <Tooltip title={t('VIEW_INVOICE')} placement='top'>
            <IconButton
              aria-label={t('DELETE')}
              onClick={() =>
                handleClickView(invoice.ticketsGli, {
                  id: invoice.invoiceId,
                  invoice_id: invoice.invoiceId,
                  invoice: invoice.invoice,
                  hauling: invoice.hauling,
                  material: invoice.material,
                  taxesMaterial: invoice.taxesMaterial,
                  wait: invoice.wait,
                  total: invoice.total,
                  balance: invoice.balance,
                  dueDate: invoice.dueDate,
                  dateCreated: invoice.dateCreated,
                  notes: invoice.notes,
                })
              }
            >
              <PreviewIcon />
            </IconButton>
          </Tooltip>
        </TableCell>
      )}

      {hasPermission(PERMISSION_MODEL.customersApplyPayment) && (
        <TableCell data-headtext={t('PAY')} align='center' size='small' padding='none'>
          <Tooltip title={t('PAY')} placement='top'>
            <IconButton
              disabled={
                changeCurrency(invoice?.balance ? invoice?.balance : '$0.00') === 0 ? true : false
              }
              aria-label={t('PAYMENTS')}
              onClick={() => {
                console.log(invoice);

                handleApplyPaymentInvoice(invoice.invoiceId);
              }}
            >
              <LocalAtmIcon />
            </IconButton>
          </Tooltip>
        </TableCell>
      )}
    </TableRow>
  );
}

function NewCustomers({ user, data }) {
  const prop_data = data;
  const [rows, setRows] = useState([]);
  const [zero, setZero] = useState(false);
  const openModalInvoice = useRef(null);
  const rechargedAfterChanges = useRef(null);
  const setMessage = useRef(null);
  const [isAllJobs, setIsAllJobs] = useState(false);
  const [tickets, setTickets] = useState([]);
  const [jobsToInvoice, setJobsToInvoice] = useState([]);
  const [infoToInvoice, setInfoToInvoice] = useState([]);
  const history = useHistory();
  const {t} = useTranslation('navigation');

  const [finish, setFinish] = useState(false);
  const [scrollNextPage, setScrollNextPage] = useState(true);
  const [totalTicketToInvoice, setTotalTicketToInvoice] = useState([]);

  // const [infoCustomer, setInfoCustomer] = useState([])
  const [balanceReciptdata, setBalanceReciptdata] = useState(null);
  // const {data,amountReceivedToApply}= balanceReciptdata
  const dispatch = useDispatch();
  //TODO check on the line 820 for Balance Receipt. Where is this shown ?
  const _showMessage = (msg, color, dataClientReceipt) => {
    setBalanceReciptdata(dataClientReceipt);
    dispatch(
      showMessage({
        message: (
          <>
            <Typography>{msg}</Typography>
            {msg === 'Update balance succesfully!' ? (
              <button onClick={handleClickOpen}>{t('BALANCE_RECEIPT')}</button>
            ) : null}
          </>
        ), //text or html
        autoHideDuration: 12000, //ms

        anchorOrigin: {
          vertical: 'top', //top bottom
          horizontal: 'right', //left center right
        },
        variant: color, //success error info warning null
      })
    );
  };

  const token = localStorage.token;

  const getData = async (customer=null) => {
    setScrollNextPage(true);
    setFinish(false);
    let _rows = [];
    setInfoToInvoice([]);
    setRows([]);
    // setInfoCustomer([])
    setTickets([]);
    setJobsToInvoice([]);
    setTotalTicketToInvoice([]);
    await getCustomers(1, customer);
    setFinish(true);
  };

  const getCustomers = async (page = 1,customer=null) => {
    //customer is to request for a specific customer to be loaded into the table ******** start here ********
    console.log('getCustomers customer ==> ',customer)
    const result = await client.get(
      `/invoices/customers/${prop_data ? prop_data.compacctnum : user.company.compacctnum}${customer ? `/${customer}` : ''}`,
      {
        params: { page },
      }
    );
    if (result?.status == 200 && Array.isArray(result.data)) {
      const data = page == 1 ? result.data : [...rows, ...result.data];
      setInfoToInvoice(data);
      setRows(data);
    }
  };

  useEffect(async () => {
    const result = await Check_refresh();
    if (!result) {
      return history.replace('/login');
    }
    setMessage.current = _showMessage;
    getData();
    rechargedAfterChanges.current = getData;
  }, [data]);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <ErrorBoundary>
      <CustomersApp
        finish={finish}
        prop_data={prop_data}
        refreshCustomers={getData}
        rows={rows}
        // setInfoCustomer={setInfoCustomer}
        // infoCustomer={infoCustomer}
        rechargedAfterChanges={rechargedAfterChanges}
        setMessage={setMessage}
        setRows={setRows}
        scrollNextPage={scrollNextPage}
        setScrollNextPage={setScrollNextPage}
      />

      <ModalAfterPay
        prop_data={prop_data}
        open={open}
        handleClose={handleClose}
        balanceReciptdata={balanceReciptdata}
        formatter={formatter}
        isCustomer={true}
      />
    </ErrorBoundary>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.loadz_auth?.AuthReducer?.user,
  };
};

export default connect(mapStateToProps, null)(memo(NewCustomers));
